import React from 'react'
import styled from 'styled-components'
import { StarIcon } from '@8x8/oxygen-icon'
import { translate } from '~/core/translate'
import { FlexCentered } from './containers'

const AiBadgeContent = styled(FlexCentered)`
  padding-right: 4px;
`

const AiBadge = () => (
  <AiBadgeContent>
    <StarIcon />{translate('ai_generated_badge')}
  </AiBadgeContent>
)

export default AiBadge
